import isinApplications from './isinApplications';
import LoadUserData from '../../LoadUserData';

export const isinApplicationsConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/isin_applications',
            component: LoadUserData(isinApplications)
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/isinApplications/isinApplicationsConfig.js